/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: utils-service.ts
 *
 * Created by sjacobs on 3/16/18.
 */

'use strict';

angular.module('prism-ui.components').service('TerritoriesService', function (
    this: JS5Object, _: JS5Object, TerritoriesResourceFactory: JS5Object) {
    this.permissionViewState = 'DASHBOARD_TERRITORIES_VIEW_STATE';
    this.originalEditData = {};

    this.getAllTerritories = (queryParams: JS5Object, queryHandler: JS5Function) => {
        return TerritoriesResourceFactory.query(queryParams, queryHandler).$promise;
    };

    this.getTerritory = (id: number) => {
        return TerritoriesResourceFactory.getTerritory({id: id}).$promise;
    };

    this.createTerritory = (territory: JS5Object) => {
        return TerritoriesResourceFactory.createTerritory(territory).$promise;
    };

    this.updateTerritory = (territory: JS5Object) => {
        return TerritoriesResourceFactory.updateTerritory(territory).$promise;
    };

    this.deleteTerritory = (id: number) => {
        return TerritoriesResourceFactory.deleteTerritory({id: id}).$promise;
    };
});
